import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { DomainList } from '@/features/domains/DomainList';
import { useTenant } from '@/lib/tenant';

function DomainListRoute() {
  const { slug } = Route.useParams();
  const { setSlug } = useTenant();
  useEffect(() => {
    setSlug(slug);
  }, [slug, setSlug]);
  return <DomainList slug={slug} />;
}

export const Route = createFileRoute('/tenants/$slug/domains/')({
  component: DomainListRoute,
});
